import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  ElementRef,
  HostListener,
  OnInit,
  inject,
  signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { interval } from 'rxjs';
import { RUTAS_FINANZAS } from '../../../funcionalidades/finanzas/rutas/finanzas-rutas.const';
import { AvisoPropioDto, AvisosPropiosServicio } from '@nucleo/avisos/avisos-propios-servicio';
import { localeActual } from '@nucleo/i18n/idioma-actual';
import { traducciones } from '@nucleo/i18n/traduccion-util';
import { formatearFechaHora } from '@compartido/crud/utilidades/crud-util';
import { TEXTOS_COMPARTIDO } from '@compartido/i18n/compartido-textos';

const SEGUNDOS_ENTRE_CONSULTAS = 60;
const MAXIMO_AVISOS_VISIBLES = 10;

/** Campana de la barra superior: avisos sin leer del usuario y su lista (al tocar uno se marca como leído). */
@Component({
  selector: 'app-campana-avisos',
  templateUrl: './campana-avisos.html',
  styleUrl: './campana-avisos.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CampanaAvisos implements OnInit {
  protected readonly servicio = inject(AvisosPropiosServicio);
  private readonly elemento = inject<ElementRef<HTMLElement>>(ElementRef);
  private readonly destruccion = inject(DestroyRef);
  private readonly router = inject(Router);

  protected readonly t = traducciones(TEXTOS_COMPARTIDO);
  protected readonly abierta = signal(false);
  protected readonly maximo = MAXIMO_AVISOS_VISIBLES;

  ngOnInit(): void {
    this.servicio.cargar();
    interval(SEGUNDOS_ENTRE_CONSULTAS * 1000)
      .pipe(takeUntilDestroyed(this.destruccion))
      .subscribe(() => this.servicio.cargar());
  }

  protected alternar(): void {
    this.abierta.update((valor) => !valor);
    if (this.abierta()) this.servicio.cargar();
  }

  protected leer(aviso: AvisoPropioDto): void {
    this.servicio.marcarLeido(aviso);
  }

  /** Lleva a la pantalla de avisos de pago para revisar los pendientes. */
  protected irAPagosPendientes(): void {
    this.abierta.set(false);
    void this.router.navigateByUrl(`/${RUTAS_FINANZAS.BASE}/${RUTAS_FINANZAS.AVISOS_PAGO}`);
  }

  protected fecha(aviso: AvisoPropioDto): string {
    return formatearFechaHora(aviso.createdAt, localeActual());
  }

  @HostListener('document:click', ['$event'])
  protected cerrarAlHacerClicFuera(evento: Event): void {
    if (this.abierta() && !this.elemento.nativeElement.contains(evento.target as Node)) this.abierta.set(false);
  }

  @HostListener('document:keydown.escape')
  protected cerrarConEscape(): void {
    this.abierta.set(false);
  }
}
